var styles = {"spacingWrapper":"tabs-section--spacing-wrapper"};

export { styles as default };
//# sourceMappingURL=TabsSection.module.esm.js.map
